
import { Watch, Component, Mixins } from 'vue-property-decorator'
import { IShowcasePageForm, IShowcasePageFormErrors } from '@/types/showcase'
import ToastMixin from '@/mixins/ToastMixin'
import { isArray } from 'lodash'
@Component
export default class ShowcaseCreateUpdate extends Mixins(ToastMixin) {
  requiredFields = ["title", "organization", "template"]
  category = null

  pageForm: IShowcasePageForm = {
    title: "",
    salutation: "",
    text: "",
    template: "",
    primary_color: "",
    organization: "",
    category: "",
    photos: [],
    logo: [],
    documents: [],
    contact_person_title: "",
    contact_person: null,
    is_public: false,
    links: [],
    show_map: false,
    show_result_reports: false,
    page_heading: ""
  }

  created (): void {
    this.pageForm.page_heading = this.$gettext("Funding page")
  }

  formErrors: IShowcasePageFormErrors = {
    title: null,
    organization: null,
    template: null,
    page_heading: null,
    description: null,
    contact_person_title: null,
    text: null
  }

  @Watch('pageForm', { deep: true })
  onMyFormChange (updatedForm) {
    this.requiredFields.forEach((field) => {
      if (updatedForm[field]) {
        this.formErrors[field] = null
      }
    })
  }

  get categoryOption (): string {
    const categoryKey = isArray(this.$route.query.category) ? this.$route.query.category[0] : this.$route.query.category
    if (categoryKey === "promotion_recommendation") {
      return "1"
    } else if (categoryKey === "funding_request") {
      return "2"
    } else if (categoryKey === "funding_result") {
      return "3"
    }
  }

  handleOrganizationSelected (organization): void {
    this.pageForm.organization = organization
  }
}
